import $ from 'jquery';

export default class Page {
  constructor(element, selector) {
    this.selector = element.selector;

    this.$ = {
      window: $(window),
      document: $(document),
      root: $(element)
    };

    if (this.$.root.length) {
      this.init();
    }
  }
  init() {
    console.warn(`Need create init method for "${this.selector}"`);
  }
  elements(elements) {
    for (let element in elements) {
      this.$[element] = this.$.root.find(elements[element]);
    }
  }
  events(events) {
    for (let event in events) {
      const { target, handler, deligate, data } = events[event];
      target.on(event, deligate, data, handler);
    }
  }
  removeRoot() {
    this.$.root.html('').remove();
    delete this.$.root;
  }
  static make(Constructor, selector) {
    return $(selector).map((i, element) => {
      element.selector = selector;
      new Constructor(element, selector);
    });
  }
}
